import React, { Component } from 'react';
import styles from './ProjectPreview.module.scss';
import Link, { withPrefix} from 'gatsby-link';
import EditableText from '../EditableText/EditableText';

export default class ProjectPreview extends Component {
	render() {
		const { project } = this.props;
		return (
			<section className={styles.project} key={project.node.fields.slug}>
	            <div className={styles.projectHeader}>
	              <div className={styles.designerName}>{project.node.frontmatter.designer}</div>
	              <Link to={project.node.fields.slug} className={styles.linkToProject}>
	              	<span className={styles.dtCTA}>
	                	View Project
	                </span>
	                <span className={styles.mobileCTA}>
	                	View
	                </span>
	                <img src={withPrefix('/arrow.svg')} className={styles.arrow}/>
	              </Link>
	            </div>
	            {project.node.frontmatter.fonts.slice(0,1).map(font => (
	              <EditableText
	                key={font.name}
	                fontName={font.name}
	                type={font.type}
	                file={font.file}
	                placeholder={font.placeholder}
	              />
	            ))}
          	</section>
        );
	}
}


// WEBPACK FOOTER //
// ./src/components/ProjectPreview/ProjectPreview.jsx